import { render, staticRenderFns } from "./add-word-configuration.vue?vue&type=template&id=7265c6f7&scoped=true"
import script from "./add-word-configuration.vue?vue&type=script&lang=ts"
export * from "./add-word-configuration.vue?vue&type=script&lang=ts"
import style0 from "./add-word-configuration.vue?vue&type=style&index=0&id=7265c6f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7265c6f7",
  null
  
)

export default component.exports